import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const getTrades = createAsyncThunk(
  "trades/getTrades",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/trades");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradesFiltered = createAsyncThunk(
  "trades/getTradesFiltered",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/trades", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradesPage = createAsyncThunk(
  "trades/getTradesPage",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/trades/page", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradesOfDateFiltered = createAsyncThunk(
  "trades/getTradesOfDateFiltered",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/trades", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradesStats = createAsyncThunk(
  "trades/getTradesStats",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/trades/stats");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradesStatsFiltered = createAsyncThunk(
  "trades/getTradesStatsFiltered",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/trades/stats", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getUserTags = createAsyncThunk(
  "trades/getUserTags",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("tag");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const createTag = createAsyncThunk(
  "trades/createTag",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { name, color } = formInfo;
      const res = await api.post("tag", { name, color });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const editTag = createAsyncThunk(
  "trades/editTag",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { tag_id, name, color } = formInfo;
      const res = await api.put(`tag/${tag_id}`, { name, color });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteTag = createAsyncThunk(
  "trades/deleteTag",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { tag_id } = formInfo;
      const res = await api.delete(`tag/${tag_id}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const setTradeTags = createAsyncThunk(
  "trades/setTradeTags",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_id, tag_ids } = formInfo;
      const res = await api.put(`trade/${trade_id}/tags`, { tag_ids });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradeTags = createAsyncThunk(
  "trades/getTradeTags",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_id } = formInfo;
      const res = await api.get(`trade/${trade_id}/tags`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
